@if (initialized) {
    <div class="grid">

<!--        <div class="col-12">-->
<!--            <im-import-data-->
<!--                    [objectId]="objectIdentifier.objectId"-->
<!--            ></im-import-data>-->
<!--        </div>-->

        <div class="col-12">
            <im-import-record
                    [importId]="objectIdentifier.objectId"
            ></im-import-record>
        </div>
    </div>
}
